import { useQuery } from "react-query";
import { deleteNursingNote, getNursingNotes } from "../../../helpers/api";
import { Loader, Modal } from "@mantine/core";
import EditNursingNote from "./edit-nursing-note";
import { useState } from "react";
import { format } from "date-fns";
import { message, Typography } from "antd";
import smalltalk from "smalltalk";

const NursingNotesComponent = ({ consultationId }) => {
  const [modal, setModal] = useState({
    isOpen: false,
    title: "",
    content: null,
    size: 500,
    zIndex: 50,
  });

  const {
    data: notes,
    isFetching,
    refetch,
  } = useQuery({
    queryFn: () => getNursingNotes(consultationId),
    queryKey: ["nursing-notes", consultationId],
  });

  const handleDeleteNote = (id) => {
    if (!id) {
      return;
    }

    smalltalk
      .confirm(
        "Delete Nursing Note",
        "Deleting this nursing note cannot be undone. Continue?",
        {
          buttons: {
            ok: "YES",
            cancel: "NO",
          },
        }
      )
      .then((go) => {
        message.info("deleting...");
        deleteNursingNote(id)
          .then((res) => {
            if (res.status === 204) {
              message.success("done!");
              refetch();
              return;
            }
          })
          .catch((ex) => {
            message.error(ex.data.message);
          });
      })
      .catch((ex) => {
        return false;
      });
  };

  const { Paragraph } = Typography;

  return (
    <>
      <Modal
        onClose={() => setModal({ ...modal, isOpen: false })}
        opened={modal.isOpen}
        title={modal.title}
        size={modal.size}
        zIndex={modal.zIndex}>
        {modal.content}
      </Modal>

      <button
        onClick={() =>
          setModal({
            isOpen: true,
            title: "Add Nursing Note",
            content: (
              <EditNursingNote
                isNewNote
                onRefresh={refetch}
                onPost={() => setModal({ isOpen: false })}
                consultationId={consultationId}
              />
            ),
            size: 700,
          })
        }
        className="button app-btn btn-prim h6">
        <span className="bi bi-plus-circle me-2" />
        Add Note
      </button>

      {isFetching && (
        <p className="mt-3">
          <Loader className="me-2" /> Fetching notes...
        </p>
      )}

      {notes &&
        notes
          ?.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
          .map((note, index) => (
            <div key={note.id} className="border rounded mt-2 p-3">
              <div className="row">
                <div className="col-1">
                  <h5>#{++index}</h5>
                </div>
                <div className="col-8">
                  <div>
                    <h6>{`${note?.user?.staff?.firstName} ${note?.user?.staff?.lastName}`}</h6>
                    <Paragraph ellipsis={{ rows: 3 }}>{note.notes}</Paragraph>
                  </div>
                  <small className="text-muted">
                    {format(new Date(note.createdAt), "MMMM dd, yyyy hh:mm a")}
                    {note?.updatedAt !== note.createdAt &&
                      " - Updated on: " +
                        format(
                          new Date(note.updatedAt),
                          "MMMM dd, yyyy hh:mm a"
                        )}
                  </small>
                </div>
                <div className="col-3 g-0">
                  <button
                    onClick={() =>
                      setModal({
                        title: "Edit Nursing Note",
                        isOpen: true,
                        size: 700,
                        content: (
                          <EditNursingNote
                            key={note.id}
                            nursingNoteId={note.id}
                            onRefresh={refetch}
                          />
                        ),
                      })
                    }
                    className="button fw-bold">
                    <span className="bi bi-eye me-2" />
                    Open
                  </button>
                  <button
                    onClick={() => handleDeleteNote(note.id)}
                    className="button fw-bold text-danger">
                    <span className="bi bi-trash" />
                  </button>
                </div>
              </div>
            </div>
          ))}
    </>
  );
};

export default NursingNotesComponent;
